// import OnlyAdmin from 'components/guards/OnlyAdmin';
import { RouteTo } from 'lib/utils/routing';
import React from 'react'
import { Link } from 'react-router-dom';
import {
	ButtonGroup,
	Card,
	DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown
} from 'reactstrap';

// import { Padding } from '../../../../lib/styles/Padding';


export default class TicketBreakdownTable extends React.Component<
	{ [label: string]: any }, { [label: string]: any }
	> {

	constructor(props) {
		super(props);
		this.toggleFilter = this.toggleFilter.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleFilter = this.handleFilter.bind(this);
		this.state = {
			filterDropdownOpen: false,
			checked: false,
			filterStatus: 'All'
		}
	}

	public toggleFilter() {
		this.setState({
			filterDropdownOpen: !this.state.filterDropdownOpen
		});
	}

	public handleFilter(obj: string) {
		this.setState({ filterStatus: obj })
	}

	public handleChange(checked) {
		if (this.state.checked !== checked) {
			this.setState({ checked });
		}
	}


	public render() {

		const currency = this.props.currency ? this.props.currency : 'USD'

		let ticketInventory: any[] = []

		if (this.props.isHostOrAdmin) {
			ticketInventory = this.props.ticketInventory.filter((item) => {
				return (item.promoterId === this.props.user.id || item.accessibleTo.includes(item))
			})
		} else {
			ticketInventory = this.props.ticketInventory
		}
		// switch (this.state.filterStatus) {
		// 	case 'All': {
		// 		ticketInventory = this.props.ticketInventory
		// 		break;
		// 	}
		// 	case 'Referral': {
		// 		ticketInventory = this.props.ticketInventory.filter((item) => {
		// 			return (item.promoterId !== undefined && item.promoterId !== null) && (item.referral !== undefined && item.referral !== null && item.referral === true)
		// 		})
		// 		break;
		// 	}
		// 	case 'Private': {
		// 		ticketInventory = this.props.ticketInventory.filter((item) => {
		// 			return (item.promoterId !== undefined && item.promoterId !== null)
		// 		})
		// 		break;
		// 	};
		// 	case 'Public': {
		// 		ticketInventory = this.props.ticketInventory.filter((item) => {
		// 			return (item.promoterId !== undefined && item.promoterId === null)
		// 		})
		// 		break;
		// 	}
		// 	default: {
		// 		ticketInventory = this.props.ticketInventory.filter((item) => {

		// 			const usrObj = this.props.promoters.find(p => {
		// 				return (p.id === item.promoterId)
		// 			})
		// 			if (usrObj !== undefined) {
		// 				return (item.promoterId !== undefined && (usrObj.name + ' ' + usrObj.lastname) === this.state.filterStatus)
		// 			} else {
		// 				return false
		// 			}
		// 		})
		// 		break;
		// 	}
		// }

		const {
			loadingTicketInventory,
			bool,
			eventId,
			temp
		} = this.props

		// const promoterArray: string[] = []
		// const promoterFilterOptions = this.props.ticketInventory.map((item) => {
		// 	if (item.promoterId !== undefined && item.promoterId !== null && !promoterArray.includes(item.promoterId)) {
		// 		promoterArray.push(item.promoterId)
		// 		const usrObj = this.props.promoters.find(p => {
		// 			return p.id === item.promoterId
		// 		})
		// 		if (usrObj === undefined) {
		// 			return null;
		// 		}
		// 		return (
		// 			<DropdownItem onClick={e => this.handleFilter(usrObj.name + ' ' + usrObj.lastname)}>{(usrObj.name + ' ' + usrObj.lastname).toUpperCase()}</DropdownItem>
		// 		)
		// 	}

		// })

		const PriceMap = {};

		// if (bool) {
		ticketInventory.forEach((item) => {
			if (PriceMap[item.price] === undefined) {
				PriceMap[item.price] = {
					bought: 0,
					activated: 0,
					checkedIn: 0,
					quantity: 0,
					cancelled: 0,
					available: 0
				}
			}
			PriceMap[item.price].bought += item.bought;
			PriceMap[item.price].activated += item.activated;
			PriceMap[item.price].checkedIn += item.checkedIn;
			PriceMap[item.price].cancelled += item.cancelled;
			if (item.quantity === -1) {
				PriceMap[item.price].infinite = true
			} else {
				PriceMap[item.price].available += (item.quantity - item.bought - item.activated);
			}
		})
		// } 
		// else {
		// 	temp.forEach((item) => {
		// 		if (item === undefined) {
		// 			return
		// 		}
		// 		if (PriceMap[item.price] === undefined) {
		// 			PriceMap[item.price] = {
		// 				bought: 0,
		// 				activated: 0,
		// 				checkedIn: 0,
		// 				quantity: 0,
		// 				cancelled: 0,
		// 				available: 0
		// 			}
		// 		}
		// 		PriceMap[item.price].bought += item.bought;
		// 		PriceMap[item.price].activated += item.activated;
		// 		PriceMap[item.price].checkedIn += item.checkedIn;
		// 		PriceMap[item.price].cancelled += item.cancelled;
		// 		if (item.quantity === -1) {
		// 			PriceMap[item.price].infinite = true
		// 		} else {
		// 			PriceMap[item.price].available += item.available;
		// 		}
		// 	})
		// }

		let promMap = {}

		this.props.promoters.map(item => {
			promMap = {
				...promMap, [item.id]: { name: item.name + ' ' + item.lastname, email: item.email }
			}
		})

		return (
			<Card
				style={{ textAlign: 'center' }}
			>
				<div>
					<p />
					<h3 className={this.props.onSale ? 'sexyBlack' : 'pause-gray'}>{this.state.checked ? 'Full Ticket Breakdown' : 'Ticket Price Breakdown'}</h3>
					<p />
					<div style={{ width: '100%', justifyContent: 'center', textAlign: 'center', margin: 'auto' }}>

						<div className="small-split-995">
							<div style={{ width: '100%' }}>
								<div style={{ width: '100%', textAlign: 'center' }}>

									{
										this.state.checked ?
											<div
												className='new-button-white-3'
												onClick={e =>
													this.handleChange(false)
												}
												style={{
													cursor: 'pointer',
													maxWidth: '150px',
												}}
											>
												PRICE BREAKDOWN
            								</div>
											:
											<div
												className='new-button-white-3'
												onClick={e =>
													this.handleChange(true)
												}
												style={{
													cursor: 'pointer',
													maxWidth: '150px'
												}}
											>
												FULL BREAKDOWN
            						</div>
									}

								</div>
								{/* <div style={{ width: '100%', textAlign: 'center' }}>
									<p />
									{this.props.isHost ?
										<UncontrolledDropdown>
											<DropdownToggle
												tag="div"
												caret={true}
												data-toggle="dropdown"
												aria-expanded={this.state.filterDropdownOpen}
											>
												<div className="new-button-white-3 cut-text" style={{ width: 'auto', maxWidth: '150px' }}>
													{('Filter: ' + this.state.filterStatus).toUpperCase()}
												</div>
											</DropdownToggle>
											<DropdownMenu >
												<DropdownItem header={true}>FILTER BY TICKET TYPE</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("All")}>ALL</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("Public")}>GENERAL</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("Private")}>PROMOTER</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("Referral")}>REFERRAL</DropdownItem>
												<DropdownItem header={true}>FILTER BY PROMOTER</DropdownItem>
												{promoterFilterOptions}
											</DropdownMenu>
										</UncontrolledDropdown>
										: null}
								</div> */}
							</div>
							<p />
						</div>
						<div className="big-split-995">
							<div style={{ width: '100%', paddingRight: '5%', paddingLeft: '5%' }}>
								<div style={{ float: 'left' }}>
									<ButtonGroup>
										{
											this.state.checked ?
												<div
													className='new-button-white-3'
													onClick={e =>
														this.handleChange(false)
													}
													style={{
														cursor: 'pointer'
													}}
												>
													PRICE BREAKDOWN
            									</div>
												:
												<div

													className='new-button-white-3'
													onClick={e =>
														this.handleChange(true)
													}
													style={{
														cursor: 'pointer'
													}}
												>
													FULL BREAKDOWN
            							</div>
										}
									</ButtonGroup>
								</div>
								{/* <div style={{ float: 'right' }}>
									{this.props.isHost ?
										<UncontrolledDropdown style={{ padding: '0 auto' }}>
											<DropdownToggle
												caret={true}
												className="new-button-white-3 cut-text"
												style={{ width: 'auto', maxWidth: '150px', paddingTop: '0px' }}
												tag="div"
											>
												{('Filter: ' + this.state.filterStatus).toUpperCase()}
											</DropdownToggle>
											<DropdownMenu >
												<DropdownItem header={true}>FILTER BY TICKET TYPE</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("All")}>ALL</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("Public")}>GENERAL</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("Private")}>PROMOTER</DropdownItem>
												<DropdownItem onClick={e => this.handleFilter("Referral")}>REFERRAL</DropdownItem>
												<DropdownItem header={true}>FILTER BY PROMOTER</DropdownItem>
												{promoterFilterOptions}
											</DropdownMenu>
										</UncontrolledDropdown>
										: null}
								</div> */}
								<p><br /><br /></p>
							</div>
						</div>
					</div>
					{
						!this.state.checked ? (
							<div style={{
								overflowX: "scroll"
							}}>
								<table
									className='table-responsive--base'
									style={{ minWidth: '550px', overflowX: 'scroll' }}
								>
									<thead>
										<tr>
											<td>PRICE</td>
											<td>BOUGHT</td>
											<td>AVAILABLE</td>
											<td>PENDING PURCHASE</td>
											<td>CHECKED-IN</td>
										</tr>
									</thead>
								</table>
								<div style={{ maxHeight: '350px' }}>
									<table className='table-responsive--base' style={{ minWidth: '550px', overflowX: 'scroll' }}>
										<tbody>
											{loadingTicketInventory
												? null
												:
												Object.keys(PriceMap).map(t => {
													const key = Number(t)
													return (
														<tr key={PriceMap[key]._id}>

															<td data-label="Price" className="sexyBlack">
																{
																	currency === 'INR' ? <span>&#8377;</span> : '$'
																}
																{key !== 0 && key !== null
																	? (key / 100).toFixed(2)
																	: 0}
															</td>
															<td data-label="Bought">
																{PriceMap[key].bought || 0}
															</td>
															<td data-label="Available">
																{PriceMap[key].infinite ? '∞ (' + this.props.capacityRemaining + ')' : (PriceMap[key].available || 0)}
															</td>
															<td data-label="Activated">
																{PriceMap[key].activated || 0}
															</td>
															<td data-label="Checked-In">
																{PriceMap[key].checkedIn || 0}
															</td>
														</tr>
													);
												})
											}
										</tbody>
									</table><p />
								</div></div>) : (
								<div style={{
									overflowX: "scroll"
								}}>
									<table className='table-responsive--base m-0' style={{ minWidth: '930px', overflowX: 'scroll' }}>
										<thead>
											<tr>
												<td>NAME</td>
												<td>GENERAL LINK</td>
												<td>PROMOTERS</td>
												<td>PRICE</td>
												<td>BOUGHT</td>
												<td>AVAILABLE</td>
												<td>PENDING PURCHASE</td>
												<td>CHECKED-IN</td>
											</tr>
										</thead>
									</table>
									<div style={{ maxHeight: '350px' }}>
										<table className='table-responsive--base' style={{ minWidth: '930px', overflowX: 'scroll' }}>
											<tbody>
												{loadingTicketInventory
													? null
													: (bool ?
														ticketInventory.map(t => {
															if (t === undefined) {
																return;
															}
															const content =
																t.referral
																	?
																	(<Link
																		to={RouteTo.referralPublic(eventId, t.promoterId)}
																		style={{ textDecoration: 'underline' }}
																	>
																		{t.name}
																	</Link>)
																	: (t.name || '')

															return (
																<tr key={t._id}>
																	<td data-label="Name" className="sexyBlack">
																		{content}
																	</td>
																	<td>
																		{
																			t.availableOnGeneralLink ? '✓' :
																				(t.promoterId === null && t.accessibleTo === null) ? '✓'
																					: ''
																		}
																	</td>
																	<td>
																		<UncontrolledDropdown style={{ padding: '0 auto' }}>
																			<DropdownToggle
																				caret={true}
																				className="new-button-white-3 cut-text"
																				style={{ width: 'auto', maxWidth: '150px', paddingTop: '0px' }}
																				tag="div"
																			>
																				View
																			</DropdownToggle>
																			<DropdownMenu >
																				{
																					t.promoterId ?
																						<DropdownItem>{promMap[t.promoterId].name}</DropdownItem>
																						:
																						t.accessibleTo && t.accessibleTo.length !== 0 ?
																							t.accessibleTo.map((prom, index) => {
																								return <DropdownItem key={index}>{promMap[prom].name}</DropdownItem>
																							}) :
																							<DropdownItem>
																								-
																							</DropdownItem>
																				}
																			</DropdownMenu>
																		</UncontrolledDropdown>
																	</td>
																	<td data-label="Price" className="sexyBlack">
																		{
																			currency === 'INR' ? <span>&#8377;</span> : '$'
																		}
																		{t.price !== 0 && t.price !== null
																			? (t.price / 100).toFixed(2)
																			: 0}
																	</td>
																	<td data-label="Bought">
																		{t.bought || 0}
																	</td>
																	<td data-label="Available">
																		{t.quantity === -1 ? '∞ (' + this.props.capacityRemaining + ')' : ((t.quantity - t.bought - t.activated) || 0)}
																	</td>
																	<td data-label="Activated">
																		{t.activated || 0}
																	</td>
																	<td data-label="Checked-In">
																		{t.checkedIn || 0}
																	</td>
																</tr>
															);
														})
														:
														temp.map(t => {
															if (t === undefined) {
																return;
															}
															const content =
																t.referral
																	?
																	(<Link
																		to={RouteTo.referralPublic(eventId, t.promoterId)}
																		style={{ textDecoration: 'underline' }}
																	>
																		{t.name}
																	</Link>)
																	: (t.name || '')

															return (
																<tr key={t._id}>
																	<td data-label="Name">
																		{content}
																	</td>
																	<td data-label="Promoter">
																		{t.promoterId !== undefined && t.promoterId !== null ? promMap[t.promoterId].name : '-'}
																	</td>
																	<td data-label="Price">
																		{
																			currency === 'INR' ? <span>&#8377;</span> : '$'
																		}
																		{t.price !== 0 && t.price !== null
																			? (t.price / 100).toFixed(2)
																			: 0}
																	</td>
																	<td data-label="Bought">
																		{t.bought || 0}
																	</td>
																	<td data-label="Available">
																		{t.quantity === -1 ? '∞ (' + this.props.capacityRemaining + ')' : (t.available || 0)}
																	</td>
																	<td data-label="Activated">
																		{t.activated || 0}
																	</td>
																	<td data-label="Checked-In">
																		{t.checkedIn || 0}
																	</td>
																</tr>
															);
														}))}
											</tbody>
										</table>
										<p />
									</div></div>)
					}
				</div>
				<p />
			</Card>
		)
	}

}


// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/TicketBreakdownTable.tsx